import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api/v1'

export default {
  namespaced: true,
  state: {
    users: [],
    loading: false,
    error: null,
    success: null
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users
    },
    ADD_USER(state, user) {
      state.users.push(user)
    },
    UPDATE_USER(state, updatedUser) {
      const index = state.users.findIndex(user => user.id === updatedUser.id)
      if (index !== -1) {
        state.users.splice(index, 1, updatedUser)
      }
    },
    REMOVE_USER(state, userId) {
      const index = state.users.findIndex(user => user.id === userId)
      if (index !== -1) {
        state.users.splice(index, 1)
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SUCCESS(state, message) {
      state.success = message
    }
  },
  actions: {
    async fetchUsers({ commit }) {
      commit('SET_LOADING', true)
      
      try {
        const response = await axios.get(`${API_URL}/users/`)
        commit('SET_USERS', response.data)
        return response.data
      } catch (error) {
        console.error('Error al obtener usuarios:', error)
        commit('SET_ERROR', error.response?.data?.detail || 'Error al obtener usuarios')
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async createUser({ commit }, userData) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_SUCCESS', null)
      
      try {
        const response = await axios.post(`${API_URL}/users/`, userData)
        commit('ADD_USER', response.data)
        commit('SET_SUCCESS', 'Usuario creado correctamente')
        return response.data
      } catch (error) {
        console.error('Error al crear usuario:', error)
        commit('SET_ERROR', error.response?.data?.detail || 'Error al crear usuario')
        return null
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async updateUser({ commit }, { userId, userData }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_SUCCESS', null)
      
      try {
        const response = await axios.put(`${API_URL}/users/${userId}`, userData)
        commit('UPDATE_USER', response.data)
        commit('SET_SUCCESS', 'Usuario actualizado correctamente')
        return response.data
      } catch (error) {
        console.error('Error al actualizar usuario:', error)
        commit('SET_ERROR', error.response?.data?.detail || 'Error al actualizar usuario')
        return null
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async deleteUser({ commit }, userId) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_SUCCESS', null)
      
      try {
        await axios.delete(`${API_URL}/users/${userId}`)
        commit('REMOVE_USER', userId)
        commit('SET_SUCCESS', 'Usuario eliminado correctamente')
        return true
      } catch (error) {
        console.error('Error al eliminar usuario:', error)
        commit('SET_ERROR', error.response?.data?.detail || 'Error al eliminar usuario')
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    clearErrors({ commit }) {
      commit('SET_ERROR', null)
      commit('SET_SUCCESS', null)
    }
  }
} 